import { defineComponent, createBlock, renderSlot, openBlock, resolveDynamicComponent, normalizeProps, mergeProps, withCtx } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Wrapper",
  props: {
    wrapper: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.wrapper ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.wrapper), normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16)) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Wrapper.vue.js.map
